import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';

import {EMPTY, Observable, throwError} from 'rxjs';
import {catchError, finalize, timeout} from 'rxjs/operators';
import {Router} from '@angular/router';
import {LoaderService} from "../common/services/loader.service";
import {AuthService} from "../../auth_modules/services/auth.service";
import {LocalStorageUtil} from "../utils/local-storage-util";
import {ObjectUtil} from "../utils/object-util";
import {AlertType} from "../common/models/alert";

@Injectable({
  providedIn: 'root',
})
export class RequestInterceptor implements HttpInterceptor {
  private isRedirecting = false;

  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private authService: AuthService
  ) {
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    let modifiedReq = req;

    const activeModule = this.getCurrentActiveModule();

    if (activeModule) {
      modifiedReq = modifiedReq.clone({
        setHeaders: {
          ModuleName: activeModule
        }
      });
    }

    const token = LocalStorageUtil.getStorage().at;

    if (!ObjectUtil.isEmpty(token)) {
      modifiedReq = modifiedReq.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    this.loaderService.showLoader();

    return next.handle(modifiedReq).pipe(
      timeout(100000),

      catchError((error) => {
        if (error.name === 'TimeoutError') {
          console.error('Request timed out');
          return throwError(() => new Error('Request timeout, please try again.'));
        }

        if (error instanceof HttpErrorResponse && error.status === 401) {
          const code = error?.error?.code;

          if (code === '5' || code == null) {
            this.handleUnauthorized(error);
            return EMPTY;
          }
        }

        return throwError(() => error);
      }),

      finalize(() => {
        this.loaderService.hideLoader();
      })
    );
  }

  private handleUnauthorized(error: HttpErrorResponse): void {
    if (this.isRedirecting) return;

    this.isRedirecting = true;
    this.loaderService.hideLoader();

    this.authService.clearLocalStorage();

    this.router.navigateByUrl('/auth/login', {
      state: {
        toast: {
          type: AlertType.ERROR,
          message:
            error?.error?.message ??
            'Session timeout. Please login again.'
        }
      }
    }).finally(() => {
      this.isRedirecting = false;
    });
  }

  private getCurrentActiveModule(): string | null {
    return sessionStorage.getItem('activeModule');
  }
}
